import { useQuery } from 'hooks'
import { useMemo } from 'react'


type New = {
  id: number
  image: string
  title: string
  teaser: string
  created_at: string
}

const useNews = () => {
  const options = useMemo(() => ({
    url: '/api/news?start_top=1&no-cache=1&per_page=2&sort[created_at]=desc',
    modifyResult: ({ data }) => {
      return data
    },
  }), [])

  const { data: news, isFetching, errors } = useQuery<New[]>(options)

  return { news, isFetching }
}

export default useNews